module.exports = __webpack_public_path__ + "static/media/bull-logo.de0b121c.svg";